const CURRENT_HOST = window.location.host;

export const getPrimaryColor = () => {
	let theme: string;

	switch (true) {
		case CURRENT_HOST.includes('pharmstd'):
			theme = 'phs';
			break;

		case CURRENT_HOST.includes('lab-industries'):
			theme = 'lab';
			break;

		case CURRENT_HOST.includes('f-soft'):
			theme = 'fsoft';
			break;

		default:
			theme = 'default';
			break;
	}

	return theme;
};
